import Modal from './Modal';

// `tone` picks the confirm button style. Defaults to 'danger' because most
// callers confirm a delete; non-destructive confirmations (e.g. marking work
// complete) must pass tone="primary" and their own confirmLabel.
const TONE_CLASS = { danger: 'btn-danger', primary: 'btn-primary' };

export default function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = 'Delete', tone = 'danger', busy }) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <p className="text-sm text-content-muted">{message}</p>
      <div className="mt-5 flex justify-end gap-2">
        <button className="btn-outline" onClick={onClose} disabled={busy}>
          Cancel
        </button>
        <button className={TONE_CLASS[tone] || TONE_CLASS.danger} onClick={onConfirm} disabled={busy}>
          {busy ? 'Working…' : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
